import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { DELIVERY_WINDOW_HOURS } from '../utils/reviewWindows';

export interface InstructorProfile {
  id: string;
  full_name: string;
  username?: string;
  profile_picture_url?: string;
  belt_rank?: string;
  turnaround_hours?: number;
}

async function fetchInstructorProfile(instructorId: string): Promise<InstructorProfile | null> {
  const { data, error } = await supabase
    .from('v_profiles_with_premium')
    .select('id, full_name, username, profile_picture_url, belt_rank')
    .eq('id', instructorId)
    .eq('is_instructor', true)
    .single();

  if (error || !data) return null;

  return {
    id:                  data.id,
    full_name:           data.full_name ?? '',
    username:            data.username ?? undefined,
    profile_picture_url: data.profile_picture_url ?? undefined,
    belt_rank:           data.belt_rank ?? undefined,
    turnaround_hours:    DELIVERY_WINDOW_HOURS,
  };
}

export function useInstructorProfileQuery(instructorId: string | undefined) {
  return useQuery({
    queryKey: ['instructor-profile', instructorId],
    queryFn:  () => fetchInstructorProfile(instructorId!),
    enabled:  !!instructorId,
    staleTime: 5 * 60 * 1000,
  });
}
